export default "__VITE_ASSET__Cmp8balM__"